import { AuthProviderIdentifier } from "../../login/AuthProviderIdentifier.js";
import { StorableSession } from "../../session/StorableSession.js";
import { CpNativeAppUpstreamBridge, GetStoredSessionResponse, NativeAppLoginResponse, NotificationDeviceInfo, ProposeSubscriptionResponse } from "../CpNativeAppIntegration.js";
import { ReactNativeWebViewProxy } from '@ciaopeople/cp-shatsu/RemoteService';
import { Logger } from "@ciaopeople/cp-shatsu/Logging";

export class CpNativeAppUpstreamBridgeImpl implements CpNativeAppUpstreamBridge {

    private proxy: ReactNativeWebViewProxy;
    
    constructor(private logger: Logger) {
        this.proxy = new ReactNativeWebViewProxy(this.logger);
    }
    getStoredSession(): Promise<GetStoredSessionResponse> {
        return this.proxy.askPublic("getStoredSession", []);
    }
    logoutExecuted(): void {
        this.proxy.fireAndForget("logoutExecuted", []);
    }
    personalDataDeletionCompleted(): void {
        this.proxy.fireAndForget("personalDataDeletionCompleted", []);
    }
    

    resolveCallback(callbackId: string, data?: any): void {
        this.proxy.resolveCallback(callbackId, data);
    }
    requireLogin(provider_suggestion: AuthProviderIdentifier): Promise<NativeAppLoginResponse> {
        return this.proxy.ask( "requireLogin", { provider_suggestion: provider_suggestion });
    }
    requireFacebookLogin(): void {
        this.proxy.fireAndForget("requireFacebookLogin", []);
    }
    requireNotificationEnable(): void {
        this.proxy.fireAndForget("requireNotificationEnable", []);
    }
    shareUrl(title: string, url: string): void {
        this.proxy.fireAndForget("share", {
            title: title,
            url: url
        });
    }
    sessionChange(session: StorableSession, device: string): void {
        this.proxy.fireAndForget("sessionChange", {
            session: {
                ...session,
                ua: {
                    os: {
                        name: device
                    }
                }
            },
        });
    }
    getNotificationDeviceInfo(): Promise<NotificationDeviceInfo> {
        return this.proxy.ask("getNotificationDeviceInfo", []);
    }

    proposeSubscription(): Promise<ProposeSubscriptionResponse> {
        return this.proxy.ask("proposeNotificationSubscription", []);
    }

    setAnalyticsUserProperties(kmap: {[k: string]: string|number|null}): void {
        this.logger.info("Propagating user properties to app",kmap);
        this.proxy.ask("setAnalyticsUserProperty", kmap);
    }

}